import styled from "styled-components";
import { SEMI_BOLD_FONT_WEIGHT } from "@/react/theme/constants";
import { CopyButton } from "@/react/components/CopyButton";
import { FieldContainer, Label } from "../styled";

const Value = styled.div`
  font-weight: ${(props) => (props.bolded ? SEMI_BOLD_FONT_WEIGHT : "unset")};
  font-family: ${(props) => (props.monospace ? "monospace" : "unset")};
  display: flex;
  gap: 8px;
`;

export const TrunkGatewayField = ({
  label,
  value,
  bolded = false,
  monospace = false,
}) => {
  return (
    <FieldContainer>
      <Label>{label}</Label>
      <Value bolded={bolded} monospace={monospace}>
        <span> {value} </span>
        <CopyButton value={value} />
      </Value>
    </FieldContainer>
  );
};
